import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IPromocion } from "../model";

export default class RegionService extends ServiceBase {
  get = (data:{ id?: number }) : Promise<IResponse<IPromocion>> => 
    this.GetFetch<IResponse<IPromocion>>('entity/promocion', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: string, nombre?: string, activo?: boolean }) : Promise<IPaginatedResponse<IPromocion>> => 
    this.GetFetch<IPaginatedResponse<IPromocion>>('entity/promocion/find', data);

  all = () : Promise<IPaginatedResponse<IPromocion>> => 
    this.GetFetch<IPaginatedResponse<IPromocion>>('entity/promocion/all', {});
    
  upsert = (data:IPromocion) : Promise<IResponse<IPromocion>> => 
    this.PostFetch<IResponse<IPromocion>>('entity/promocion', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/promocion', data);  
}